import type { FC } from 'react';
import { useTranslation, Trans } from 'react-i18next';
// @dynamic-i18n-keys
// studio.discountModal.form.appliesToCategoryInput.option.*
//   studio.discountModal.form.appliesToProductInput.option.*
import { getAppliesToBabelKeyNew } from '../DiscountPreviewCard/helpers';
import { formatDate } from '@wix/da-i18next/pkg/time/functions';

import s from './DiscountDetails.scss';

export interface DiscountDetailsData {
  appliesToProduct: string;
  discountValue: string;
  audience: string;
  startTimestamp: number;
  endTimestamp: number;
}

interface Props {
  data: DiscountDetailsData;
}

const DiscountDetails: FC<Props> = ({ data }) => {
  const { t, i18n } = useTranslation();
  const { appliesToProduct, discountValue, audience, startTimestamp, endTimestamp } = data;
  // appliesToProduct here comes from API response (appliesto field), which is the final value
  const appliesToString = t(getAppliesToBabelKeyNew(appliesToProduct));

  return (
    <div className={s['root']}>
      <div className={s['label']}>{t('studio.successModal.discountDetails')}</div>
      {discountValue &&
        (appliesToProduct === 'any_tier' || (appliesToProduct && discountValue !== '100')) && (
          <div>
            {t('studio.discountPreview.percentDiscount', {
              discount: discountValue,
            })}{' '}
            {appliesToProduct === 'any_tier' && (
              <span>{t('studio.discountPreview.onFirstMonthOnly')}</span>
            )}{' '}
            on {appliesToString}
          </div>
        )}
      {audience && (
        <div>
          <Trans i18nKey={`studio.discountPreview.audience.openTo.${audience}`} />
        </div>
      )}
      {startTimestamp && (
        <div>
          {t('studio.shop.discount.starts')}{' '}
          {formatDate(
            startTimestamp,
            {
              month: 'short',
              day: 'numeric',
              year: 'numeric',
            },
            i18n.language
          )}
          ,{' '}
          {formatDate(
            startTimestamp,
            {
              hour: 'numeric',
              hour12: true,
            },
            i18n.language
          )}
        </div>
      )}
      {endTimestamp && (
        <div>
          {t('studio.shop.discount.ends')}{' '}
          {formatDate(
            endTimestamp,
            {
              month: 'short',
              day: 'numeric',
              year: 'numeric',
            },
            i18n.language
          )}
          ,{' '}
          {formatDate(
            endTimestamp,
            {
              hour: 'numeric',
              hour12: true,
            },
            i18n.language
          )}
        </div>
      )}
    </div>
  );
};

DiscountDetails.displayName = 'DiscountDetails';

export default DiscountDetails;
